import React from 'react';
import { Foto } from './Comunes.jsx';
import { clp } from '../utiles/fechas.js';

export function SedeDetail({ sede, go }) {
  const s = sede;
  const fotos = s.fotos || [];

  return (
    <>
      <div className="wrap detail">
        <div className="gallery">
          <Foto url={fotos[0]} cls="gmain" label={s.comuna} />
          <div className="gside">
            <Foto url={fotos[1]} cls="gs" />
            <Foto url={fotos[2]} cls="gs" />
          </div>
        </div>

        <div className="d-head">
          <div>
            <div className="d-eyebrow">{s.comuna} · Centro TUNE</div>
            <h1 className="d-title">{s.nombre}</h1>
            <div className="d-meta">{s.direccion}</div>
            <div className="d-meta">
              Abierto {s.apertura}–{s.cierre} · sesiones de {s.bloque_min} min
            </div>
          </div>
          <div className="d-price">
            <div className="amt">{clp(s.precio_tune)}</div>
            <div className="lab">por sesión</div>
          </div>
        </div>

        {s.descripcion ? <p className="d-desc">{s.descripcion}</p> : null}

        <div className="offer-row">
          <div>
            <div className="offer-h">Servicios</div>
            <div className="offer-note">Consulta y contrata en el centro.</div>
            {(s.servicios || []).length === 0
              ? <div className="empty-off">Solo sesión TUNE por ahora.</div>
              : s.servicios.map((o, i) => (
                <div key={i} className="offer">
                  <div>
                    <div className="on">{o.nombre}</div>
                    {o.descripcion ? <div className="od">{o.descripcion}</div> : null}
                  </div>
                  <div className="op">{clp(o.precio)}</div>
                </div>
              ))}
          </div>

          <div>
            <div className="offer-h">Bonos</div>
            <div className="offer-note">Paquetes de sesiones. Se compran en el centro.</div>
            {(s.bonos || []).length === 0
              ? <div className="empty-off">Este centro aún no ofrece bonos.</div>
              : s.bonos.map((b, i) => (
                <div key={i} className="offer">
                  <div>
                    <div className="on">{b.nombre} <span className="bono-badge">Bono</span></div>
                    <div className="od">{b.sesiones} sesiones</div>
                  </div>
                  <div className="op">{clp(b.precio)}</div>
                </div>
              ))}
          </div>
        </div>
      </div>

      <div className="cta-bar"><div className="cta-in">
        <div className="cta-info">
          <div className="l1">Sesión TUNE · {s.comuna}</div>
          <div className="l2">{clp(s.precio_tune)} · pagas en el centro</div>
        </div>
        <button className="btn" onClick={() => go('book', s.id)}>Reservar sesión</button>
      </div></div>
    </>
  );
}
